import { atom } from 'jotai';

export interface ISettingsAtom {
	notifications: {
		notification: boolean;
		lessons: boolean;
		quran: boolean;
		duaa: boolean;
		azan: boolean;
	};
	prayerTimesSettings: {
		Fajr: boolean;
		IqamatFajr: boolean;
		Sonnenaufgang: boolean;
		Dhuhr: boolean;
		Asr: boolean;
		Maghrib: boolean;
		Isha: boolean;
	};
}

export const SettingsAtom = atom<ISettingsAtom>({
	notifications: {
		notification: false,
		lessons: false,
		quran: false,
		duaa: false,
		azan: false,
	},
	prayerTimesSettings: {
		Fajr: false,
		IqamatFajr: false,
		Sonnenaufgang: false,
		Dhuhr: false,
		Asr: false,
		Maghrib: false,
		Isha: false,
	},
});

export const dialogOpenAtom = atom(false);
